import useSWR from 'swr';
import { oauth } from '../../../utils';

type ForwardStatusResponse = { group?: string; status?: string };

export default function useForwardApplicationStatus(applicationId?: string | null) {
  const { data, error, isLoading, mutate } = useSWR(
    applicationId ? `forward-payments/applications/${applicationId}` : null,
    async (url: string) => {
      const { json } = await oauth('GET', url, {});
      return json as ForwardStatusResponse;
    },
    { revalidateOnFocus: false, revalidateOnReconnect: false },
  );

  return {
    loading: isLoading,
    group: data?.group ?? null,
    status: data?.status ?? null,
    error: error ?? null,
    refetch: mutate,
  };
}
